import { render } from "./Order.vue?vue&type=template&id=52be8164&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=52be8164&scoped=true&lang=scss"

import exportComponent from "D:\\projects\\APP\\vue3-ewshop\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52be8164"]])

export default __exports__